import { render } from "./BibleFinderFooter.vue?vue&type=template&id=2729579d"
import script from "./BibleFinderFooter.vue?vue&type=script&lang=js"
export * from "./BibleFinderFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\git\\js\\bible_finder_ui_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__